import buildThreadSections from '@/lib/threads/buildThreadSections.js';
import buildSidebarOnboardingThreadItem from '@/lib/threads/buildSidebarOnboardingThreadItem.js';
import isOnboardingThreadType from '@/lib/threads/isOnboardingThreadType.js';
import isRelevantSidebarThreadItem from '@/lib/threads/isRelevantSidebarThreadItem.js';
import sortThreadBranchesByLatestActivity from '@/lib/threads/sortThreadBranchesByLatestActivity.js';

const isOnboardingThreadItem = (threadItem = {}) => {
  return isOnboardingThreadType(threadItem?.threadType);
};

const buildSidebarThreadCollectionsFromThreadItems = ({ threadItems = [], projectMetaById = {}, activeProjectId = null, sortBy = 'created', showMode = 'all' } = {}) => {
  const threadSections = buildThreadSections({
    threadItems,
    projectMetaById,
    activeProjectId
  });
  const nestedRootThreadItems = sortThreadBranchesByLatestActivity({
    items: threadSections.flatMap((section) => section?.threadItems || [])
  });
  const resolvedOnboardingThreadItems = nestedRootThreadItems.filter((item) => isOnboardingThreadItem(item));
  const onboardingThreadItems = resolvedOnboardingThreadItems.length > 0 ? resolvedOnboardingThreadItems : [buildSidebarOnboardingThreadItem()];
  const pinnedThreadItems = nestedRootThreadItems.filter((item) => item?.pinned && !isOnboardingThreadItem(item));
  const shouldShowRelevantOnly =
    String(showMode || '')
      .trim()
      .toLowerCase() === 'relevant';

  return {
    onboardingThreadItems,
    pinnedThreadItems,
    activeProjectId: threadSections.find((section) => section?.isActive)?.projectId || null,
    threadSections: threadSections.map((section) => {
      const visibleThreadItems = (section?.threadItems || []).filter((item) => {
        if (item?.pinned || isOnboardingThreadItem(item)) {
          return false;
        }

        if (!shouldShowRelevantOnly) {
          return true;
        }

        return isRelevantSidebarThreadItem(item);
      });

      return {
        ...section,
        threadItems: sortThreadBranchesByLatestActivity({
          items: visibleThreadItems,
          sortBy
        })
      };
    })
  };
};

export default buildSidebarThreadCollectionsFromThreadItems;
